import React, { FC, useState } from 'react';
import { useIntl, getLocale } from 'umi';
import classnames from 'classnames';
import Style from './index.less';

interface Props {
  onChange: (checked: boolean) => void;
}

const FirstEnter: FC<Props> = ({ onChange }) => {
  const { formatMessage } = useIntl();
  const [checked, setChecked] = useState(false);

  return (
    <div className={Style.firstEnter}>
      <label className={Style.checkbox}>
        <input type="checkbox" checked={checked} readOnly />
        <span
          className={Style.checkmark}
          onClick={() => {
            setChecked(!checked);
            onChange(!checked);
          }}
        />
      </label>
      <span className={Style.agree}>{formatMessage({ id: 'NOTIFY_PARTICIPANTS' })}</span>
    </div>
  );
};

export default FirstEnter;
